<template>
  <div class="position-relative">
    <div class="sale-tax-rate-btn-wrapper mb-3">
      <set-sales-tax-rate :disabled="!canEdit || disabled" />
    </div>

    <ib-charts-placeholder v-if="isRevenueStreamsEmpty" />
    <el-tabs
      v-else
      v-model="activeTab"
      class="tabs"
    >
      <el-tab-pane
        :label="$t('timeline')"
        name="first"
        lazy
      >
        <div class="bg-white pt-4 pb-1">
          <revenue-over-time v-if="activeTab === 'first'" chart-animations />
        </div>
      </el-tab-pane>

      <!-- Breakdown -->
      <el-tab-pane
        :label="$t('breakdown')"
        name="second"
        lazy
      >
        <div class="bg-white pt-4 pb-1">
          <revenue-distribution v-if="activeTab === 'second'" chart-animations />
        </div>
      </el-tab-pane>

      <!-- Table -->
      <el-tab-pane
        :label="$t('table')"
        name="third"
        lazy
      >
        <div class="bg-white pt-4 pb-2">
          <revenue-streams-table />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import RevenueDistribution from '@/views/Home/StoryMode/FinancialPlan/Components/Revenue/RevenueDistribution.vue'
import RevenueOverTime from '@/views/Home/StoryMode/FinancialPlan/Components/Revenue/RevenueOverTime.vue'
import RevenueStreamsTable from '@/views/Home/StoryMode/Forecast/RevenueStreams/Tables/RevenueStreamsTable.vue'
import SetSalesTaxRate from '@/views/Home/StoryMode/Forecast/RevenueStreams/SetSalesTaxRate.vue'

export default {
  name: 'RevenueStreamsTabs',

  components: {
    SetSalesTaxRate,
    RevenueStreamsTable,
    RevenueOverTime,
    RevenueDistribution
  },

  mixins: [MixinIdeaRoles],

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      activeTab: 'first'
    }
  },

  computed: {
    ...mapState(['idea']),

    isRevenueStreamsEmpty () {
      return !this.idea.storyMode.forecast.revenueStreams.revenueStreams.length
    }
  }
}
</script>

<style scoped lang="scss">
.sale-tax-rate-btn-wrapper {
  display: flex;
  justify-content: flex-end;

  @include media-breakpoint-up($md) {
    position: absolute;
    top: -20px;
    right: 0;
    margin-bottom: unset;
  }
}

.tabs {
  ::v-deep {
    .el-tabs__content {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 0 0 8px 8px;
    }
  }
}
</style>
